import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ControlService from "../../helper/controlservice";
import * as formsAction from "../../redux/actions/formsAction";
import { toast } from 'react-toastify';
import Message from "../../helper/component/Message";
import Modal from 'react-modal';
import DynamicformInit from '../DynamicformInit';
import ReactTooltip from 'react-tooltip';
import * as Actions from "../../redux/actions/loginAction";
import { sendnotificationQue, RefreshComponentOnClose, extractErrorMessage, printPDF } from './_private';
import { initiateAuth, isQuickbookRegistered } from './_quickBooks';
import { settings } from '../../config/settings';
import SignatureCanvas from 'react-signature-canvas'

const uuidv4 = require('uuid/v4');

var redirectUrl = "";
function mapStateToProps(state) {
    return {
        data: state.formDataReducer,
        filterdata: state.formDataReducer.filterdata,
        editformdata: state.formDataReducer.editformdata,
        token: state.formLoginReducer.token,
        hasErrored: state.formDataReducer.hasErrored,
        isLoading: state.formDataReducer.isLoading,
        isSidebarOpened: state.formDataReducer.isSidebarOpened,
        isModelOpened: state.formDataReducer.isModelOpened,
        sidebarFormName: state.formDataReducer.sidebarFormName,
        sidebarFormId: state.formDataReducer.sidebarFormId,
    };
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(formsAction.updateData(key, value, storekey)),
        resetEditData: (data) => dispatch(formsAction.resetEditFormData(data)),
        resetData: (data, storekey) => dispatch(formsAction.resetFormData(data, storekey)),
        resetSidebar: (data) => dispatch(formsAction.resetSidebar(data)),
        resetModelPopup: (data) => dispatch(formsAction.resetModelPopup(data)),
        setModelFormId: (data) => dispatch(formsAction.setModelFormId(data)),
        setSidebarFormId: (data) => dispatch(formsAction.setSidebarFormId(data)),
        setSplitViewFormId: (data) => dispatch(formsAction.setSplitViewFormId(data)),
        setGUID: (data) => dispatch(formsAction.setGUID(data)),
        setPageParams: (data) => dispatch(formsAction.setPageParams(data)),
        setUploadFromSubmit: (data) => dispatch(formsAction.setUploadFromSubmit(data)),
        dataIsLoading: (bool) => dispatch(formsAction.dataIsLoading(bool)),
        setreload: (bool) => dispatch(formsAction.setreload(bool)),
        authSetToken: (data) => dispatch(Actions.authSetToken(data)),
    };
}

class CustomButton extends React.PureComponent {
    state = {
        isApiCalling: false,
        messagefromsubmit: null,
        isSubmitModelOpened: false,
        isModelOpened: false,
        modalformid: null,
        isQuickbookRegistered: false,
        openAddSignature: false
    }
    componentDidMount() {
        const { control, token, formid } = this.props;
        var data = this.props.data[formid];
        if (control.actiontype == 'quickbooks') {
            this.isQuickbooksAthenticated();
        }
        if (control.actiontype == 'pdfconverter' && control.checkPdfOnload) {
            this.pdfConverter(control, token, data ? data : {}, 'no');
        }
        ControlService().controlVaildationCheck(this.props);
    }
    isDisabled(control, formid, returnInvalidList) {
        var formvalid = true;
        let InvalidList = []
        if (control.novalidationcheck) {
            return !formvalid;
        } else {
            const formvalidation = this.props.data[formid + "_validation"]
            if (formvalidation) {
                var arr = [];
                Object.keys(formvalidation).forEach(
                    (key) => {
                        var ignorekey = control.ignorevalidationcontrols ? control.ignorevalidationcontrols.find(x => x.toLowerCase() === key.toLowerCase()) : null;
                        if (!ignorekey) {
                            const value = formvalidation[key] ? formvalidation[key] : {};
                            arr.push({ "key": key, "value": value.status, "control": value.control });
                        }
                    }
                );
                InvalidList = arr.filter(item => item.value == 'fail');
                if (arr.length > 0 && InvalidList.length > 0) {
                    formvalid = false;
                }
            }

            return returnInvalidList ? InvalidList : !formvalid;
        }
    }
    print(control) {
        var data = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {};

        if (control.printcontainerkey && control.printcontainerkey != undefined && control.printcontainerkey != '') {
            var printContents = document.getElementById(control.printcontainerkey);
            var styles = document.getElementsByTagName('style');
            var links = document.getElementsByTagName('link');
            var title = control.printtitle && data[control.printtitle] ? data[control.printtitle] : control.printtitle ? control.printtitle : '';
            try {
                if (window) {
                    var pri = window.open('', '_blank', 'width=1100,height=650,top=120,left=120,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');

                    pri.document.open();
                    pri.document.write('<!DOCTYPE html><html><head><title>' + title + '</title>');
                    for (let i = 0; i < links.length; i++) {
                        pri.document.write(links[i].outerHTML);
                    }
                    for (let i = 0; i < styles.length; i++) {
                        pri.document.write(styles[i].outerHTML);
                    }
                    pri.document.write('</head><body onload="window.print()"><div class="cameo print"><div class="container-fluid">');
                    pri.document.write(printContents.outerHTML);
                    pri.document.write('</div></div></body></html>');
                    pri.document.close();
                    pri.focus();
                    pri.onbeforeunload = function (event) {
                        pri.close();
                        return '.\n';
                    };
                    pri.onabort = function (event) {
                        pri.document.close();
                        pri.close();
                    }
                }
            } catch (e) {
                console.log(e);
            }
            return true;
        }
    }
    handleSignature(action) {
        debugger;
        const { control, formid } = this.props;
        if (action == 'save') {
            var img = this.sigCanvas.toDataURL({
                format: 'png',
                width: 400, height: control.dsHeight ? control.dsHeight : 200
            });
            if (this.sigCanvas.isEmpty()) {
                img = '';
            }
            this.props.update(control.key, img, formid);
            if (control.enablesubmitonsignature) {
                var data = this.props.data[formid] ? this.props.data[formid] : {};
                data[control.key] = img;
                this.submit(false, control, data);
            }

            this.setState({ openAddSignature: false });
        } else {
            this.sigCanvas.clear();
            if (control.resetbgimageonclear) {
                this.uploadBackgroundSignImage();
            }
        }
    }
    async customAction(control, data) {
        debugger;
        let path = '';
        var menu = ControlService().setParam(control, data, this.props.token.menu);
        var Token = this.props.token;
        Token.menu = menu;
        this.props.authSetToken(Token);

        if (control.actiontype == 'pdfconverter') {
            this.pdfConverter(control, Token, data, 'yes');
        } else if (control.actiontype == 'signature') {
            this.setState({ openAddSignature: true });
        } else if (control.actiontype === "redirect" && control.isexternalurl) {
            if (control.buttonredirecttype === "submitredir" || control.buttonredirecttype === "submitredirNew" || control.buttonredirecttype === "submitredirNewWindow") {
                this.submit(null);
            } else {
                var url = '';
                if (control.isdynamicurl) {
                    let redirecturl = data[control.RedirectUrlAttribute]
                    if (control.PrimaryKey) {
                        url = redirecturl + '?' + (control.primarynode ? control.primarynode : control.PrimaryKey) + '=' + data[control.PrimaryKey];
                    } else {
                        url = redirecturl;
                    }
                } else {
                    if (control.buttonredirecturl.indexOf('?') > -1 && control.PrimaryKey && control.isprimarynodefromresponse) {
                        url = control.buttonredirecturl + "&" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + "=" + data[control.PrimaryKey];
                    } else if (control.buttonredirecturl.indexOf('?') > -1 && control.PrimaryKey && !control.isprimarynodefromresponse) {
                        url = control.buttonredirecturl + "&" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + "=" + data[control.PrimaryKey];
                    } else if (control.PrimaryKey && control.isprimarynodefromresponse) {
                        url = control.buttonredirecturl + "?" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + "=" + data[control.PrimaryKey];
                    } else if (control.PrimaryKey && !control.isprimarynodefromresponse) {
                        url = control.buttonredirecturl + "?" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + "=" + data[control.PrimaryKey];
                    } else {
                        url = control.buttonredirecturl;
                    }
                }
                if (control.buttonredirecttype === 'sametab') {
                    window.open(url, '_self');
                } else if (control.buttonredirecttype === 'newtab') {
                    window.open(url, '_blank');
                } else {
                    window.open(url, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=100,width=1200,height=700')
                }
            }
        } else if (control.actiontype == 'sidebar' && !control.Api) {
            this.props.setPageParams(data);
            // ControlService().SetParamUrl(control.PrimaryKey, data[control.PrimaryKey]);
            // this.openPopup(control);
            var key = control.primarynode ? control.primarynode : control.PrimaryKey;
            ControlService().SetParamUrl(key, data[control.PrimaryKey]);

            this.props.resetModelPopup(!this.props.isModelOpened);
            this.props.setModelFormId(control.actionformid);
        } else if (control.actiontype == 'sidebar' && control.Api) {
            this.props.setPageParams(data);
            this.submit(null);
        } else if (control.actiontype == 'quickbooks') {
            if (this.state.quickbooksAuthenticated) {
                toast.success(<Message title={'Quickbooks'} message={'Quickbooks Athenticated!!!'} type="success" />)
                return;
            }
            this.setState({ isApiCalling: true });
            this.props.dataIsLoading(true);
            var response = await initiateAuth(Token);
            this.props.dataIsLoading(false);
            this.setState({ isApiCalling: false });
            debugger;
            // let authUrl = new URL(response.data);
            // authUrl.searchParams.set('redirect_url', window.location.origin + '/quickbooks/auth');
            var QuickBooksWnd = window.open(response.data, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=200,width=900,height=500');
            var QuickBooksWndInterval = setInterval(() => {
                if (QuickBooksWnd.closed) {
                    clearInterval(QuickBooksWndInterval);
                    this.isQuickbooksAthenticated();
                }
            }, 100);

            // QuickBooksWnd.addEventListener('beforeunload', () => {
            //     debugger;
            // });
        } else if (control.actiontype == 'Scrolltotop') {
            this.scrollTop();
        } else if (control.actiontype === 'Back') {
            this.context.history.goBack();
        } else if (control.actiontype === 'Print') {
            this.print(control);
        } else if (control.buttonredirecttype === 'newtab') {
            if (control.isdynamicurl) {
                let redirecturl = data[control.RedirectUrlAttribute]
                if (control.PrimaryKey) {
                    path = redirecturl + '?' + (control.primarynode ? control.primarynode : control.PrimaryKey) + '=' + data[control.PrimaryKey];
                } else {
                    path = redirecturl;
                }
                window.open(path, '_blank');
            } else {
                if (control.PrimaryKey) {
                    path = control.buttonredirecturl + '?' + (control.primarynode ? control.primarynode : control.PrimaryKey) + '=' + data[control.PrimaryKey];
                } else {
                    path = control.buttonredirecturl;
                }
                window.open(path, '_blank');
            }
        } else if (control.buttonredirecttype === 'sametab') {
            if (control.isdynamicurl) {
                let redirecturl = data[control.RedirectUrlAttribute]
                if (control.PrimaryKey) {
                    path = redirecturl + '?' + (control.primarynode ? control.primarynode : control.PrimaryKey) + '=' + data[control.PrimaryKey];
                } else {
                    path = redirecturl;
                }
            } else {
                if (control.PrimaryKey) {
                    path = control.buttonredirecturl + '?' + (control.primarynode ? control.primarynode : control.PrimaryKey) + '=' + data[control.PrimaryKey];
                } else {
                    path = control.buttonredirecturl;
                }
            }
            if (this.context.history) {
                this.context.history.push(path);
            }
        } else if (control.buttonredirecttype === 'submitredirNew' || control.buttonredirecttype === 'submitredir' || control.buttonredirecttype === 'submitredirNewWindow') {
            this.submit(null);
        } else if (control.buttonredirecttype === 'newwindow') {
            if (control.PrimaryKey) {
                path = control.buttonredirecturl + "?" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + '=' + data[control.PrimaryKey];
                window.open(path, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=100,width=1200,height=700')
            } else {
                path = control.buttonredirecturl;
                window.open(path, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=100,width=1200,height=700')
            }
            // if (control.PrimaryKey && control.PrimaryKey !== '') {
            //     window.open(redirectUrl + "?id=" + encodeURIComponent(this.buildRedirectUrl(control.buttonredirecturl)) + "&" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + '=' + data[control.PrimaryKey], '_blank'
            //         , 'toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=100,width=1200,height=700')
            // } else {
            //     window.open(redirectUrl + "?id=" + encodeURIComponent(this.buildRedirectUrl(control.buttonredirecturl)), '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=100,width=1200,height=700')
            // }
        }
    }
    pdfConverter(control, Token, data, regenerate, IsNewEntry) {
        if (control.PrimaryKey && data[control.PrimaryKey]) {
            this.props.dataIsLoading(true);
            printPDF(control, Token, data, this.props.formid, regenerate).then(res => {
                this.props.dataIsLoading(false);
                res = ControlService().ApiResponse(res);
                if (res.status == "success") {
                    data[control.pdfresponsemodelkey ? control.pdfresponsemodelkey : control.key] = res.data;
                    this.props.update(control.pdfresponsemodelkey ? control.pdfresponsemodelkey : control.key, res.data, this.props.formid);
                    if (regenerate == 'yes') {
                        this.SendNotifications(IsNewEntry, control, data);
                        ControlService().toastSuccess("PDF file generated successfully.");
                    }
                    this.forceUpdate();
                    if (control.generateandopenpdf) {
                        window.open(res.data, '_blank');
                    }
                } else {
                    if (regenerate) {
                        ControlService().toastError("Error occured,Please try again or contact support.");
                    }
                    this.props.update(control.pdfresponsemodelkey ? control.pdfresponsemodelkey : control.key, '', this.props.formid);
                }
                RefreshComponentOnClose(control, this.props.formid, this.props);
            }).catch(err => {
                ControlService().toastError("Error occured,Please try again or contact support.");
                this.props.dataIsLoading(false);
                RefreshComponentOnClose(control, this.props.formid, this.props);
            });
        } else if (regenerate) {
            ControlService().toastError("No data available for PDF print.Please save the form and try again.");
        }
    }

    async isQuickbooksAthenticated() {
        this.setState({ isApiCalling: true });
        let _isQuickbookRegistered = await isQuickbookRegistered(this.props.token);
        if (_isQuickbookRegistered.data === true) {
            this.setState({ quickbooksAuthenticated: true });
        }
        this.setState({ isApiCalling: false });
    }

    formwizrdNext() {
        const { control } = this.props;
        if (control.formwizardmoveback) {
            this.props.update(control.formwizardkey + '_back', uuidv4(), control.formwizardcomponentformid ? (control.formwizardcomponentformid + 'write') : this.props.formid);
        } else {
            if (control.submitandmovenext) {
                this.submit();
            } else {
                this.props.update(control.formwizardkey + '_next', uuidv4(), control.formwizardcomponentformid ? (control.formwizardcomponentformid + 'write') : this.props.formid);
            }
        }
    }
    submit(issubmitonconfirm) {
        const { formid } = this.props;
        var control = ControlService().deepcopy(this.props.control);
        var data = this.props.data[this.props.formid];
        debugger;
        if (control.enableValidationOnClick) {
            const formvalidation = this.props.data[formid + "_validation"] ? this.props.data[formid + "_validation"] : {}
            let InValidControls = [];
            for (let key in data) {
                let __control = formvalidation[key] && formvalidation[key].control ? formvalidation[key].control : {};
                if (__control.require) {
                    var _data = data[key];
                    var validation = ControlService().validate(__control, _data);
                    if (validation) {
                        this.props.update(key, { "status": "pass", "control": __control, touched: false }, formid + "_validation")
                    } else {
                        InValidControls.push({ control: __control });
                        this.props.update(key, { "status": "fail", "control": __control, touched: false }, formid + "_validation")
                    }
                }
            }
            // let InValidControls = this.isDisabled(control, formid, true);
            if (InValidControls.length > 0) {
                let message = extractErrorMessage(InValidControls)
                ControlService().toastError(message, 'Errors found in the form')
                return;
            }
        }
        this.setState({
            isApiCalling: true
        });
        this.props.dataIsLoading(true);
        var dataModel = this.props.data[formid];
        let url = "";

        let apiparam = {};

        var IsNewEntry = dataModel[control.primarykey] && dataModel[control.primarykey] != "" && dataModel[control.primarykey] != 0 ? false : true;

        if (issubmitonconfirm && control.calladditionalapi) {
            url = control.confirmapiurl;
            control.apiparam = control.confirmapiaparam;
            control.confirmapiaparam.forEach(option => {
                if (option.isdatamodel) {
                    apiparam[option.key] = data[option.value];
                } else {
                    apiparam[option.key] = option.value;
                }
            })
        } else {
            if (IsNewEntry) {
                url = control.Api;
                if (!control.method) {
                    control.method = "post";
                }
                control.apiparam = control.paramlist;
                control.paramlist.forEach(option => {
                    if (option.isdatamodel) {
                        apiparam[option.key] = data[option.value];
                    } else {
                        apiparam[option.key] = option.value;
                    }
                })
            } else {
                url = control.updateApi;
                var updateparamlist = control.updateparamlist ? control.updateparamlist : [];
                control.apiparam = updateparamlist;
                updateparamlist.forEach(option => {
                    apiparam[option.key] = option.value;
                })
            }
        }
        if (!IsNewEntry) {
            control.headers = control.updateheaders;
            control.connection = control.updateconnection;
            control.datasource = control.updatedatasource;
            if (control.updatemethod) {
                control.method = control.updatemethod;
            } else {
                control.method = "post";
            }
            if (control.enablelogupdate) {
                control.enablelog = true;
                control.logdescription = control.logdescriptionupdate;
            }
        } else {
            if (control.enablelogcreate) {
                control.enablelog = true;
                control.logdescription = control.logdescriptioncreate;
            }
        }
        if (control.guidfield && control.guidfield.trim() != "") {
            dataModel[control.guidfield] = uuidv4();
        }
        if (IsNewEntry) {
            dataModel["createdby"] = this.props.token.user.id;
            dataModel["createddate"] = new Date();
        }

        dataModel["updatedby"] = this.props.token.user.id;
        dataModel["updateddate"] = new Date();

        if (control.deletemodelitems && control.deletemodelitems.length > 0) {
            control.deletemodelitems.forEach(item => {
                delete dataModel[item];
            })
        }
        if (url && this.props.token.loginMethod && (ControlService().isGitPublishApi(url) || ControlService().isGitCrendentialApi(url))) {
            if (ControlService().isGitCrendentialApi(url)) {
                url = settings.REACT_APP_AZURE_FUNCTION_ENDPOINT + '/api/github/crendential';
            } else if (ControlService().isGitPublishApi(url)) {
                url = settings.REACT_APP_AZURE_FUNCTION_ENDPOINT + '/api/github/publish';
            }
        }
        ControlService().ServiceRequest(url, apiparam, control, this.props.token, JSON.stringify(dataModel), null, null, null, this.props)
            .then(res => {
                res = ControlService().ApiResponse(res);
                this.props.dataIsLoading(false);
                this.setState({
                    isApiCalling: false
                });
                if (res.status == "success") {
                    if (control.harddelete) {
                        if (Array.isArray(control.deletemodelitemsaftersubmit) && control.deletemodelitemsaftersubmit.length > 0) {
                            control.deletemodelitemsaftersubmit.forEach(item => {
                                delete data[item];
                            })
                            this.props.resetData(data, this.props.formid);
                        }
                    }
                    if (control.attachwithformwizard) {
                        this.props.update(control.formwizardkey + '_next', uuidv4(), control.formwizardcomponentformid ? (control.formwizardcomponentformid + 'write') : this.props.formid);
                    }
                    if (control.isfileuploadonsubmit) {
                        let _message = {}
                        if (IsNewEntry && control.successmsgtitle) {
                            _message.text = control.successmsgtext;
                            _message.title = control.successmsgtitle;
                            _message.icon = control.successmsgicon;
                        } else if (!IsNewEntry && control.updatemsgtitle) {
                            _message.text = control.updatemsgtext;
                            _message.title = control.updatemsgtitle;
                            _message.icon = control.updatemsgicon;
                        } else {
                            if (IsNewEntry) {
                                _message.text = res.message;
                                _message.title = control.successmsgtitle;
                                _message.icon = control.successmsgicon;
                            } else {
                                _message.text = res.message;
                                _message.title = control.updatemsgtitle;
                                _message.icon = control.updatemsgicon;
                            }
                            // this.changeSuccessMessage(res.message ? res.message : null);
                        }
                        var btnparams = {};
                        if (control.fileuploadonsubmitparams && control.fileuploadonsubmitparams.length > 0 && res.data) {
                            control.fileuploadonsubmitparams.forEach(item => {
                                btnparams[item] = res.data[item];
                            })
                        }
                        var uploadparams = {
                            formParams: btnparams,
                            successmessage: _message
                        }
                        this.props.setUploadFromSubmit(uploadparams);
                    } else {
                        if (control.refreshcomponentonclose == "update") {
                            toast.success(<Message message={res.message ? res.message : null} type="success" />)
                        } else if (control.refreshcomponentonclose || control.actiontype != "sidebar") {
                            if (IsNewEntry && control.successmsgtitle) {
                                toast.success(<Message icon={control.successmsgicon} title={control.successmsgtitle} message={control.successmsgtext} type="success" />)
                            } else if (control.updatemsgtitle) {
                                toast.success(<Message icon={control.updatemsgicon} title={control.updatemsgtitle} message={control.updatemsgtext} type="success" />)
                            } else if (res.message) {
                                toast.success(<Message message={res.message ? res.message : null} type="success" />)
                            }
                        }
                    }
                } else if (res.status == "error") {
                    if (control.errormsgtitle) {
                        ControlService().toastError(control.errormsgtext, control.errormsgtitle, control.errormsgicon)
                    } else {
                        ControlService().toastError(res.message, control.errormsgicon);
                    }
                } else {
                    toast.error(<Message icon={control.errormsgicon} message={res.message} type="error" />);
                }
                this.status = res.status;
                if (res.status === "success") {
                    this.submitOnSucess(control, res, dataModel, formid, IsNewEntry, issubmitonconfirm, data);
                }
            })
            .catch(err => {
                this.props.dataIsLoading(false);
                this.setState({
                    isApiCalling: false
                });
                toast.error(<Message icon={control.errormsgicon} message={err.message} type="error" />)
                console.log(err.message);
            });

    }
    submitOnSucess(control, res, dataModel, formid, IsNewEntry, issubmitonconfirm, data) {
        let response = {};
        if (res && res.hasOwnProperty("data") && typeof (res.data) === 'object') {
            response = res.data
        } else if (res && typeof (res) === 'object') {
            response = res
        }
        if (control.enableautovalidateonsubmit) {
            var resValue = null;
            if (control.responsefield) {
                resValue = response[control.responsefield];
            } else if (res && res.hasOwnProperty("data")) {
                resValue = response;
            } else {
                resValue = res;
            }
            dataModel[control.key] = resValue;
            this.props.update(control.key, resValue, formid);
        }
        if (control.resetallform) {
            this.props.resetData(response, control.responseformid ? (control.responseformid + 'write') : formid);
        } else if (Array.isArray(control.responsefields) && control.responsefields.length > 0) {
            let _formid = control.responseformid ? (control.responseformid + 'write') : formid;
            control.responsefields.forEach(responsefield => {
                this.props.update(responsefield, response[responsefield], _formid);
            });
        }
        if (control.printpdf) {
            this.pdfConverter(control, this.props.token, dataModel, 'yes', IsNewEntry);
        } else {
            this.SendNotifications(IsNewEntry, control);
            RefreshComponentOnClose(control, formid, this.props);
        }

        if (control.actiontype === 'submit' && !issubmitonconfirm && control.submitonconfirm && control.calladditionalapi) {
            var _confirmMsg = null;
            if (control.responsefieldfrommessage) {
                if (res.data && Array.isArray(res.data) && res.data.length > 0) {
                    _confirmMsg = res.data[0][control.responsefieldfrommessage];
                } else if (res.data && typeof res.data == 'object') {
                    _confirmMsg = res.data[control.responsefieldfrommessage];
                }
            }
            this.setState({ messagefromsubmit: _confirmMsg, isSubmitModelOpened: true });
            // this.submitonconfirm(null, null, contentSubmitConfirm, true, _confirmMsg);
        } else if (control.actiontype == 'sidebar' && control.showinpopup) {
            toast.success(<Message message={res.message ? res.message : null} type="success" />);
            // this.openPopup(control);
            ControlService().SetParamUrl(control.primarynode ? control.primarynode : control.PrimaryKey, data[control.PrimaryKey]);

            this.props.resetModelPopup(!this.props.isModelOpened);
            this.props.setModelFormId(control.actionformid);
        } else if (control.actiontype === "sidebar" && !control.showinpopup) {
            toast.success(<Message message={res.message ? res.message : null} type="success" />);
            this.opensidebar(control, data);
        } else if (control.actiontype === "redirect" && control.isexternalurl && control.buttonredirecturl) {
            let _url = '';
            if (control.buttonredirecturl.indexOf('?') > -1 && control.PrimaryKey && control.isprimarynodefromresponse) {
                _url = control.buttonredirecturl + "&" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + "=" + res.data[control.PrimaryKey];
            } else if (control.buttonredirecturl.indexOf('?') > -1 && control.PrimaryKey && !control.isprimarynodefromresponse) {
                _url = control.buttonredirecturl + "&" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + "=" + data[control.PrimaryKey];
            } else if (control.PrimaryKey && control.isprimarynodefromresponse) {
                _url = control.buttonredirecturl + "?" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + "=" + res.data[control.PrimaryKey];
            } else if (control.PrimaryKey && !control.isprimarynodefromresponse) {
                _url = control.buttonredirecturl + "?" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + "=" + data[control.PrimaryKey];
            } else {
                _url = control.buttonredirecturl;
            }
            if (control.buttonredirecttype === 'submitredir') {
                window.open(_url, '_self');
            } else if (control.buttonredirecttype === 'submitredirNew') {
                window.open(_url, '_blank');
            } else {
                window.open(_url, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=100,width=1200,height=700');
            }
        } else if (control.actiontype === "redirect" && control.buttonredirecttype === "submitredir") {
            if (control.isdynamicurl) {
                let redirecturl = data[control.RedirectUrlAttribute] ? data[control.RedirectUrlAttribute] : res[control.RedirectUrlAttribute];
                if (control.PrimaryKey) {
                    let path = redirecturl + '?' + (control.primarynode ? control.primarynode : control.PrimaryKey) + '=' + (data[control.PrimaryKey] ? data[control.PrimaryKey] : res.data[control.PrimaryKey]);
                    this.context.history.push(path);
                } else {
                    let path = redirecturl;
                    this.context.history.push(path);
                }
            } else {
                if (control.PrimaryKey) {
                    let path = control.buttonredirecturl + '?' + (control.primarynode ? control.primarynode : control.PrimaryKey) + '=' + (data[control.PrimaryKey] ? data[control.PrimaryKey] : res.data[control.PrimaryKey]);
                    this.context.history.push(path);
                } else {
                    let path = control.buttonredirecturl;
                    this.context.history.push(path);
                }
            }
        } else if (control.actiontype === "redirect" && control.buttonredirecttype === "submitredirNew") {
            if (control.successmsgtitle) {
                toast.success(<Message icon={control.successmsgicon} title={control.successmsgtitle} message={control.successmsgtext} type="success" />);
            }
            if (control.isdynamicurl) {
                let redirecturl = data[control.RedirectUrlAttribute] ? data[control.RedirectUrlAttribute] : res[control.RedirectUrlAttribute];
                if (control.PrimaryKey) {
                    let path = redirecturl + '?' + (control.primarynode ? control.primarynode : control.PrimaryKey) + '=' + (data[control.PrimaryKey] ? data[control.PrimaryKey] : res.data[control.PrimaryKey]);
                    window.open(path, '_blank');
                } else {
                    let path = redirecturl;
                    window.open(path, '_blank');
                }
            } else {
                if (control.PrimaryKey) {
                    let path = control.buttonredirecturl + '?' + (control.primarynode ? control.primarynode : control.PrimaryKey) + '=' + (data[control.PrimaryKey] ? data[control.PrimaryKey] : res.data[control.PrimaryKey]);
                    window.open(path, '_blank');
                } else {
                    let path = control.buttonredirecturl;
                    window.open(path, '_blank');
                }
            }
        } else if (control.actiontype === "redirect" && control.buttonredirecttype === "submitredirNewWindow") {
            if (control.successmsgtitle) {
                toast.success(<Message icon={control.successmsgicon} title={control.successmsgtitle} message={control.successmsgtext} type="success" />);
            }
            if (control.PrimaryKey && control.PrimaryKey !== '') {
                window.open(redirectUrl + "?id=" + encodeURIComponent(this.buildRedirectUrl(control.buttonredirecturl)) + "&" + (control.PrimaryKey ? control.PrimaryKey : control.primarynode) + '=' + data[control.PrimaryKey], '_blank',
                    'toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=100,width=1200,height=700');
            } else {
                window.open(redirectUrl + "?id=" + encodeURIComponent(this.buildRedirectUrl(control.buttonredirecturl)), '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=100,width=1200,height=700');
            }
        }
    }

    SendNotifications(IsNewEntry, control, data) {
        if (IsNewEntry) {
            this.sendnotification("create", control, data);

        } else {
            this.sendnotification("update", control, data);
        }
    }

    submitPinnedModel(control, formid) {
        var _pinnedData = this.props.data["pinneditems"] ? this.props.data["pinneditems"] : [];
        let url = control.Api;
        if (_pinnedData.length == 0) {
            toast(<Message message={"Item not selected !"} />)
        }
        _pinnedData.forEach((_dataModel, index) => {
            this.props.dataIsLoading(true);
            var ModelJson = null;
            let apiparam = {};
            if (!control.enablerowquery) {
                ModelJson = _dataModel;
                control.paramlist.forEach(option => {
                    if (!option.ispagevarible)
                        apiparam[option.key] = option.value;
                    else {
                        var paramVal = ControlService().GetParamUrl(option.value)
                        if (paramVal) {
                            apiparam[option.key] = paramVal;
                        } else {
                            apiparam[option.key] = option.value;
                        }
                    }
                })
            }
            else {
                var rowQuery = control.rowquery;
                control.paramlist.forEach(option => {
                    if (!option.ispagevarible)
                        rowQuery = rowQuery.replace("{{" + option.key + "}}", _dataModel[option.value] ? _dataModel[option.value] : null);
                    else {
                        var paramVal = ControlService().GetParamUrl(option.value)
                        if (paramVal) {
                            rowQuery = rowQuery.replace("{{" + option.key + "}}", paramVal);
                        } else {
                            rowQuery = rowQuery.replace("{{" + option.key + "}}", option.value);
                        }
                    }
                })

                ModelJson = JSON.parse(rowQuery);
            }


            if (control.createdby && control.createdby.trim() != "") {
                // ModelJson[control.createdby] = "khushbu.brahmbhatt";
            }
            if (control.updatedby && control.updatedby.trim() != "") {
                // ModelJson[control.updatedby] = "khushbu.brahmbhatt";
            }
            if (!control.method) {
                control.method = "post";
            }
            control.apiparam = control.paramlist;
            ControlService().ServiceRequest(url, apiparam, control, this.props.token, JSON.stringify(ModelJson))
                .then((res) => {
                    this.props.dataIsLoading(false);
                    if (index == _pinnedData.length - 1) {
                        this.props.resetData([], "pinneditems");
                        if (res.status == 'error') {
                            toast.error(<Message icon={control.errormsgicon} message={control.errormsgtext ? control.errormsgtext : res.message} type="error" />)
                        } else {
                            toast.success(<Message icon={control.successmsgicon} title={control.successmsgtitle} message={control.successmsgtext} type="success" />)
                        }
                        if (control.refreshcomponentonclose) {
                            if (res.status == 'error') {
                                toast.error(<Message icon={control.errormsgicon} message={control.errormsgtext ? control.errormsgtext : res.message} type="error" />)

                            } else {
                                toast.success(<Message icon={control.successmsgicon} title={control.successmsgtitle} message={control.successmsgtext} type="success" />)
                            }
                        }
                        if (control.sidebarcloseonsubmit && this.props.isSidebarOpened) {
                            this.props.setPageParams(null);
                            this.props.resetSidebar(!this.props.isSidebarOpened);
                            this.props.setSidebarFormId(null);
                            this.props.resetData(null, this.props.sidebarFormId + "write_validation");
                        }
                    }
                })
                .catch(err => {
                    console.log(err.message);
                    this.props.dataIsLoading(false);
                });
        });
    }
    sendnotification(action, control, data) {
        var datamodel = data ? data : this.props.data[this.props.formid]
        sendnotificationQue(action, control, datamodel, this.props.token);
    }
    buildRedirectUrl(buttonredirecturl) {
        var _index = -1;
        let _redirectUrl = buttonredirecturl;

        if (_redirectUrl) {
            var arr = _redirectUrl.split('');
            arr.forEach((char, i) => {
                if (/^[a-zA-Z]*$/g.test(char) && _index == -1) {
                    _index = i;
                }
            });
            if (_index == -1) {
                _index = 0;
            }
            return _redirectUrl.substring(_index)
        } else {
            return _redirectUrl;
        }


    }
    scrollTop() {

        if (document.getElementsByClassName("modal") && document.getElementsByClassName("modal").length > 0) {
            document.getElementsByClassName("modal")[0].scrollTop = 0;
        } else if (document.getElementsByClassName('custom-sidebar-outer sidebar-open') && document.getElementsByClassName('custom-sidebar-outer sidebar-open').length > 0) {
            document.getElementsByClassName('custom-sidebar-body')[0].scrollTop = 0;
        } else {
            const userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
            const isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
            if (isSafari) {
                document.body.scrollTop = 0;
            } else {
                document.documentElement.scrollTop = 0;
            }
        }
    }
    openPopup(control) {
        this.setState({
            isModelOpened: true,
            modalformid: control.actionformid
        })
    }
    closeModal() {
        this.setState({
            isModelOpened: false,
            modalformid: null
        })
    }
    opensidebar(control, data) {

        ControlService().SetParamUrl(control.primarynode ? control.primarynode : control.PrimaryKey, data[control.PrimaryKey]);
        var menu = ControlService().setParam(control, data, this.props.token.menu);
        var Token = this.props.token;
        Token.menu = menu;
        this.props.authSetToken(Token);

        this.props.setPageParams(data);
        this.props.resetSidebar(!this.props.isSidebarOpened);
        this.props.setSidebarFormId(control.actionformid);
        // this.props.resetSidebarFormName(!this.props.isSidebarOpened);
    }
    afterOpenModal() {
        debugger;
        if (this.state.openAddSignature) {
            this.uploadBackgroundSignImage();
        }
    }
    uploadBackgroundSignImage() {
        const { control, formid } = this.props;
        if (control.uploadSignatureBackgroundImage) {
            var data = this.props.data[formid] ? this.props.data[formid] : {};

            var imageUrl = '';
            imageUrl = data[control.uploadSignatureBackgroundImage] ? data[control.uploadSignatureBackgroundImage] : control.uploadSignatureBackgroundImage;

            const toDataURL = url => fetch(url)
                .then(response => response.blob())
                .then(blob => new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                }));

            if (control.uploadSignatureBackgroundImageType === 'base64string') {
                this.sigCanvas.fromDataURL(imageUrl, {
                    width: 400, height: control.dsHeight ? control.dsHeight : 200
                });
            } else {
                toDataURL(imageUrl)
                    .then(dataUrl => {
                        this.sigCanvas.fromDataURL(dataUrl, {
                            width: 400, height: control.dsHeight ? control.dsHeight : 200
                        });
                    });
            }
        }
    }

    render() {
        const { control, action, formid } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        var customStyle = {};
        if (control.styles) {
            try {
                customStyle = JSON.parse(control.styles);
            } catch {
                customStyle = {};
            }
        }
        return (
            <React.Fragment>

                {
                    control.enableValidationOnClick ?
                        this.renderButton(control, action, customStyle, data)
                        : this.isDisabled(control, formid) ?
                            <button data-tip data-for={control.id} disabled={true}
                                style={{ ...customStyle, cursor: 'not-allowed' }}
                                className={' btn ' + control.coutomClass + ' btn-' + control.buttontype + ' btn-' + control.size}>
                                {control.WebIcon && control.WebIconPosition != 'right' &&
                                    <i className={control.WebIcon + (control.label ? ' mr-2' : '')}></i>
                                }
                                {control.bindbuttonlabelwithdata ? data[control.key] : control.label}
                                {control.WebIcon && control.WebIconPosition == 'right' &&
                                    <i className={control.WebIcon + (control.label ? ' ml-2' : '')}></i>
                                }
                            </button>
                            : this.renderButton(control, action, customStyle, data)
                }
                <Modal
                    isOpen={this.state.isSubmitModelOpened || this.state.openAddSignature}
                    onAfterOpen={() => this.afterOpenModal()}
                    onRequestClose={() => this.setState({ isSubmitModelOpened: false, openAddSignature: false })}
                    style={{
                        content: {
                            top: '50%',
                            left: '50%',
                            right: 'auto',
                            bottom: 'auto',
                            marginRight: '-50%',
                            transform: 'translate(-50%, -50%)',
                            maxWidth: '90%',
                            maxHeight: '90%'
                        }
                    }}
                    overlayClassName='cameo'
                    shouldCloseOnOverlayClick={true}
                >
                    {control.dsHeader &&
                        <div className="modal-header d-flex align-items-center">
                            <h4 className="mb-0">{control.dsHeader}</h4>
                            <i className="fa fa-times fa-lg ml-auto" onClick={(() => this.setState({ isSubmitModelOpened: false, openAddSignature: false }))}></i>
                        </div>
                    }
                    <div className="modal-body">
                        {
                            control.actiontype == 'signature' ?
                                <SignatureCanvas penColor={control.dsPenColor ? control.dsPenColor : 'black'}
                                    ref={(ref) => { this.sigCanvas = ref }}
                                    canvasProps={{ width: 400, height: control.dsHeight ? control.dsHeight : 200, className: 'sigCanvas' }}
                                    backgroundColor={control.dsBackgroundColor}

                                />
                                :
                                <div className="d-flex align-items-center justify-content-center">
                                    <div>
                                        {control.responsefieldfrommessage && <p className="mb-0 word-break">
                                            {this.state.messagefromsubmit}
                                        </p>
                                        }
                                        {control.confirmmessage && <p className="mb-0 word-break">
                                            {control.confirmmessage}
                                        </p>
                                        }
                                    </div>
                                </div>
                        }
                    </div>
                    <div className="modal-footer">
                        {
                            control.actiontype == 'signature' ?
                                <>
                                    <button type="button" className={"mr-3 btn btn-secondary"} onClick={(e) => this.handleSignature()}>{control.dsClearText ? control.dsClearText : 'Clear'}</button>
                                    <button type="button" className={"btn btn-" + (control.buttontype ? control.buttontype : 'success')} onClick={(e) => {
                                        e.preventDefault();
                                        this.handleSignature('save')
                                        this.setState({ isSubmitModelOpened: false })
                                    }}>
                                        {control.dsConfirmText ? control.dsConfirmText : 'Confirm'}
                                    </button>
                                </>
                                : <>
                                    {!control.hidecancelbutton && <button type="button" className={"mr-3 btn btn-" + (control.cancelbuttontype ? control.cancelbuttontype : 'danger')} onClick={() => this.setState({ isSubmitModelOpened: false, openAddSignature: false })}>{control.cancelbuttontext ? control.cancelbuttontext : 'Cancel'}</button>}
                                    <button type="button" className={"btn btn-" + (control.confirmbuttontype ? control.confirmbuttontype : 'success')} onClick={(e) => {
                                        e.preventDefault();
                                        if (control.actiontype == 'submit') {
                                            this.submit(false)
                                        } else {
                                            this.customAction(control, data)
                                        }
                                        this.setState({ isSubmitModelOpened: false })
                                    }}>
                                        {control.confirmbuttontext ? control.confirmbuttontext : 'Save'}
                                    </button>
                                </>
                        }
                    </div>
                </Modal>
                {control.tooltip &&
                    <ReactTooltip place={control.tooltipplacement ? control.tooltipplacement : 'top'} id={control.id} aria-haspopup='true' role='example'>
                        <span>{control.tooltip}</span>
                    </ReactTooltip>
                }
            </React.Fragment>
        );
    }

    renderButton(control, action, customStyle, data) {
        return !control.submitpinneditems && action != 'edit' && control.actiontype == 'submit' ?
            <button data-tip data-for={control.id} onClick={(e) => {
                e.preventDefault();
                if (control.submitonconfirm) {
                    this.setState({ isSubmitModelOpened: true });
                } else {
                    control.attachwithformwizard ? this.formwizrdNext() : this.submit();
                }
            }}
                className={' btn ' + control.coutomClass + ' btn-' + control.buttontype + ' btn-' + control.size}
                style={customStyle}
                disabled={this.props.disabled}
            >
                {control.WebIcon && control.WebIconPosition != 'right' &&
                    <i className={control.WebIcon + (control.label ? ' mr-2' : '')}></i>}
                {control.bindbuttonlabelwithdata ? data[control.key] : control.label}
                {control.WebIcon && control.WebIconPosition == 'right' &&
                    <i className={control.WebIcon + (control.label ? ' ml-2' : '')}></i>}
            </button>
            :
            control.submitpinneditems && action == 'write' && control.actiontype == 'submit' ?
                <button data-tip data-for={control.id}
                    onClick={(e) => { e.preventDefault(); this.submit(); document.body.click(); }}
                    className={' btn ' + control.coutomClass + ' btn-' + control.buttontype + ' btn-' + control.size}
                    style={customStyle}
                    disabled={this.props.disabled}
                >
                    {control.WebIcon && control.WebIconPosition != 'right' &&
                        <i className={control.WebIcon + (control.label ? ' mr-2' : '')}></i>}
                    {control.bindbuttonlabelwithdata ? data[control.key] : control.label}
                    {control.WebIcon && control.WebIconPosition == 'right' &&
                        <i className={control.WebIcon + (control.label ? ' ml-2' : '')}></i>}
                </button>
                : control.actiontype == 'sidebar' && !control.showinpopup ?
                    <button data-tip data-for={control.id}
                        className={'btn ' + control.coutomClass + ' btn-' + control.buttontype + ' btn-' + control.size}
                        onClick={(e) => { e.preventDefault(); this.opensidebar(control, data); document.body.click(); }}
                        style={customStyle}
                        disabled={this.props.disabled}
                    >
                        {control.WebIcon && control.WebIconPosition != 'right' &&
                            <i className={control.WebIcon + (control.label ? ' mr-2' : '')}></i>}
                        {control.bindbuttonlabelwithdata ? data[control.key] : control.label}
                        {control.WebIcon && control.WebIconPosition == 'right' &&
                            <i className={control.WebIcon + (control.label ? ' ml-2' : '')}></i>}
                    </button>

                    : (control.actiontype == 'sidebar' && control.showinpopup)
                        || control.actiontype == 'Print'
                        || control.actiontype == 'redirect'
                        || control.actiontype == 'Scrolltotop'
                        || control.actiontype == 'Back'
                        || control.actiontype == 'quickbooks'
                        || control.actiontype == 'signature'
                        || control.actiontype == 'pdfconverter' ?
                        <React.Fragment>
                            <button data-tip data-for={control.id}
                                className={' btn ' + control.coutomClass + ' btn-' + control.buttontype + ' btn-' + control.size}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (control.submitonconfirm) {
                                        this.setState({ isSubmitModelOpened: true });
                                    } else {
                                        this.customAction(control, data);
                                    }
                                    document.body.click();
                                }}
                                style={customStyle}
                                disabled={this.props.disabled || this.state.quickbooksAuthenticated || this.state.isApiCalling}
                            >
                                {control.WebIcon && control.WebIconPosition != 'right' &&
                                    <i className={control.WebIcon + (control.label ? ' mr-2' : '')}></i>}
                                {control.bindbuttonlabelwithdata ? data[control.key] : control.label}
                                {control.WebIcon && control.WebIconPosition == 'right' &&
                                    <i className={control.WebIcon + (control.label ? ' ml-2' : '')}></i>}
                            </button>
                            {control.actiontype == 'sidebar' && control.showinpopup &&
                                <Modal
                                    isOpen={this.state.isModelOpened}
                                    // onAfterOpen={() => this.afterOpenModal()}
                                    onRequestClose={() => this.closeModal()}
                                    style={{
                                        content: {
                                            top: '10%',
                                            left: '10%',
                                            right: '10%',
                                            bottom: '10%'
                                        }
                                    }}
                                    overlayClassName='cameo'
                                    shouldCloseOnOverlayClick={false}
                                >
                                    <div className="modal-header d-flex align-items-center">
                                        <h4 className="mb-0">{this.props.sidebarFormName}</h4>
                                        <i className="fa fa-times fa-lg ml-auto" onClick={((e) => this.closeModal())}></i>
                                    </div>
                                    <div className="modal-body">
                                        <DynamicformInit key={this.props.pageparams ? (JSON.stringify(this.props.pageparams) + this.state.modalformid) : this.state.modalformid}
                                            formid={this.state.modalformid}
                                            dataid={''}
                                            formui={null}
                                            datamodel={null}
                                            access={'write'}
                                            pageparams={{}}
                                            authtoken={this.props.token} />
                                    </div>
                                </Modal>}
                        </React.Fragment>
                        : null;
    }
}
CustomButton.contextTypes = {
    isAddFormClicked: PropTypes.string,
    history: PropTypes.object
};
export default connect(
    mapStateToProps, bindAction
)(CustomButton);